import React, { useState } from 'react'

import AuthUser from '../../components/AuthUser';
import { getListaPrecioCadenas } from '../../api/requestProductos';

const ExcelJS = require("exceljs")

export const ListaPrecioWadfowXLS = () => {

  const { user } = AuthUser();
  const ZonasVenta = user.ZonasVenta;
  const [data, setData] = useState([]);
  const [enableBtn, setEnableBtn] = useState(true)

  const toDataURL = (url) => {
    const promise = new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.readAsDataURL(xhr.response);
        reader.onloadend = function () {
          resolve({ base64Url: reader.result });
        };
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    });

    return promise;
  };

  const exportExcelFile = async () => {
    setEnableBtn(false)
    const resProductos = await getListaPrecioCadenas(user.CodVendedor, ZonasVenta, 'WADFOW');
    setData(resProductos)
    const workbook = new ExcelJS.Workbook()
    const sheet = workbook.addWorksheet("Lista de precios WADFOW")

    const encabezadoRow = sheet.getRow(1)

    encabezadoRow.height = 25
    encabezadoRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF6B00' }
    }
    encabezadoRow.font = {
      name: "Arial",
      family: 4,
      size: 14,
      bold: true,
      color: { argb: 'FFFFFF' },
    }

    const commonColumns = [
      { header: "Codigo", key: "codigo", width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      { header: "Nombre", key: "nombre", width: 40, style: { alignment: { vertical: 'middle' } } },
      { header: "Precio", key: "precio", width: 10, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      { header: "Existencia", key: "existencia", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      { header: "Pedido Sugerido", key: "ventaMinima", width: 25, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      { header: "Imagen", key: "imageId2", width: 25, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      { header: "Codigo de Barras", key: "codigoBarras", width: 25, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      { header: "Grupo", key: "grupo", width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      { header: "Subgrupo", key: "subgrupo", width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
    ];

    if (ZonasVenta === "001,003,004,CCS") {
      sheet.columns = [
        ...commonColumns,
        { header: "Empresa", key: "empresa", width: 25, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      ];
    } else {
      sheet.columns = commonColumns;
    }

    const promise = Promise.all(
  resProductos.map(async (product, index) => {
    const rowNumber = index + 1; // Ajusta rowNumber para que empiece desde 1 si tu lógica de addImage lo necesita
                                // Nota: sheet.addRow() agrega a la siguiente fila disponible,
                                // por lo que index + 1 es el número de fila que se está agregando.

    // === Lógica para determinar la empresa (CARACAS o MARACAIBO) ===
    let empresaValor = ''; // Inicializa la variable para la empresa
   
    if (ZonasVenta === "001,003,004,CCS") {
      if (product.Empresa === "CCS") {
        empresaValor = "CARACAS";
      } else {
        empresaValor = "MARACAIBO";
      }
    } else {
      // Opcional: ¿Qué pasa si ZonasVenta no es "001,003,004,CCS"?
      // Podrías asignarle un valor por defecto o dejarlo vacío.
      // Por ejemplo:
      empresaValor = "Otra Zona"; // O simplemente '' o null
    }
    // === Fin de la lógica de la empresa ===

    // Agrega la fila con todos los datos, incluyendo la 'empresa' calculada
    sheet.addRow({
      codigo: product.Codigo,
      rutaImagen: product.RutaImagen, // Asegúrate de que esta key esté definida en sheet.columns si la usas para datos
      nombre: product.Nombre,
      precio: product.Precio,
      existencia: product.Existencia,
      ventaMinima: product.VentaMinima,
      // Nuevas columnas que quizás necesites añadir a sheet.columns:
      cantidadapedir: '', // Si esta es una columna real, debería tener una key en sheet.columns
      subtotal: '',       // Si esta es una columna real, debería tener una key en sheet.columns
      codigoBarras: product.CodigoBarras,
      grupo: product.Grupo,
      subgrupo: product.Subgrupo,
      // Aquí agregamos el valor de la empresa
      empresa: empresaValor,
    });

    const result = await toDataURL(product.RutaImagen);
    const splitted = product.RutaImagen.split(".");
    const extName = splitted[splitted.length - 1];
    const imageId2 = workbook.addImage({
      base64: result.base64Url,
      extension: extName,
    });

    // La imagen se agrega a la fila que acabamos de añadir
    // rowNumber se está usando para el cálculo de la fila de la imagen,
    // si usas sheet.addRow() directamente, la fila de la imagen debería coincidir.
    // Si sheet.addRow(rowData) automáticamente incrementa la fila, quizás necesites
    // obtener el número de fila de otra manera o ajustar `rowNumber` para que `sheet.addRow`
    // no lo use pero la imagen sí.
    // Para asegurar que la imagen se asocie a la fila correcta, considera:
    // 1. Que `rowNumber` coincida con el índice real de la fila en la hoja de cálculo.
    //    Si `sheet.addRow` añade al final, `index + 1` generalmente funcionará.
    // 2. Si necesitas un control más preciso, puedes capturar la fila y su número.
    sheet.addImage(imageId2, {
      tl: { col: 5, row: rowNumber }, // Esto debería ser el número de fila real en la hoja
      ext: { width: 120, height: 120 },
    });
    sheet.getRow(rowNumber + 1).height = 95; // Ajusta la altura de la fila siguiente o actual si es necesario
  })
);

promise.then(() => {
  workbook.xlsx.writeBuffer().then(function (data) {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "Lista de Precio Cadenas INGCO.xlsx";
    anchor.click();
    window.URL.revokeObjectURL(url);
    setEnableBtn(true);
  });
});
  }

  return (
    <>
      <div className='d-md-block d-none'>
        {
          (enableBtn) ?
            <button onClick={exportExcelFile} className='btn btn-hoverWadfow btn-sm mb-2 w-100'><strong>Generar Lista de Precios WADFOW</strong></button>
            :
            <button className='btn btn-hoverWadfow btn-sm mb-2 w-100 disabled' disabled><strong>Generar Lista de Precios WADFOW</strong></button>
        }
      </div>
    </>
  )
}
